import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=519c3c8d&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style1 from "./Login.vue?vue&type=style&index=1&id=519c3c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c3c8d",
  null
  
)

export default component.exports